import { render, staticRenderFns } from "./GChatDateLabel.vue?vue&type=template&id=35b8a652&scoped=true&"
import script from "./GChatDateLabel.vue?vue&type=script&lang=ts&"
export * from "./GChatDateLabel.vue?vue&type=script&lang=ts&"
import style0 from "./GChatDateLabel.vue?vue&type=style&index=0&id=35b8a652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b8a652",
  null
  
)

export default component.exports